/* AtlasMall theme JS — no dependencies */
(function () {
  'use strict';
  var cfg = window.AtlasMall || {};
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function toast(msg, isError) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.hidden = true; }, 3200);
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n < 1; });
  }

  function refreshCount() {
    return fetch(cfg.cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); });
  }

  function addToCart(items) {
    return fetch(cfg.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || cfg.error);
        return d;
      });
    }).then(refreshCount);
  }

  /* Mobile navigation */
  var nav = $('[data-nav]');
  function setNav(open) {
    if (!nav) return;
    nav.classList.toggle('is-open', open);
    var btn = $('[data-nav-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-nav-open]')) { setNav(true); return; }
    if (t.closest('[data-nav-close]')) { setNav(false); return; }

    /* Quick add from product cards */
    var qa = t.closest('button[data-quick-add]');
    if (qa) {
      qa.classList.add('is-loading');
      addToCart([{ id: Number(qa.getAttribute('data-quick-add')), quantity: 1 }])
        .then(function () { toast(cfg.added); })
        .catch(function (err) { toast(err.message || cfg.error, true); })
        .then(function () { qa.classList.remove('is-loading'); });
      return;
    }

    /* Quantity steppers (product + cart) */
    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('input', step.parentNode);
      var min = input.hasAttribute('data-cart-qty') ? 0 : 1;
      var v = (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-qty-step'));
      input.value = Math.max(min, v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* Gallery thumbnails */
    var th = t.closest('[data-thumb]');
    if (th) { showSlide(th.closest('[data-gallery]'), Number(th.getAttribute('data-thumb'))); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });

  /* Auto-submit selects (language, sort) and cart quantity */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-auto-submit]') && t.form) { t.form.submit(); }
    if (t.matches && t.matches('[data-cart-qty]') && t.form) { t.form.submit(); }
  });

  /* Filters: submit when a checkbox or price field changes */
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function (e) {
      if (e.target.matches('input')) f.submit();
    });
  });
  var fw = $('[data-filters-wrap]');
  if (fw && window.matchMedia('(min-width: 900px)').matches) fw.open = true;

  /* Product page */
  function showSlide(gallery, index) {
    if (!gallery) return;
    $$('[data-slide]', gallery).forEach(function (s) { s.hidden = Number(s.getAttribute('data-slide')) !== index; });
    $$('[data-thumb]', gallery).forEach(function (b) {
      if (Number(b.getAttribute('data-thumb')) === index) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
  }

  $$('[data-product]').forEach(function (root) {
    var form = $('[data-product-form]', root);
    if (!form) return;
    var dataEl = $('[data-variants]', root);
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    var idInput = $('[data-variant-id]', form);
    var btn = $('[data-add]', form);
    var now = $('[data-price-now]', root);
    var was = $('[data-price-was]', root);

    function update(v) {
      if (!v) { btn.disabled = true; form.dataset.soldout = 'true'; return; }
      idInput.value = v.id;
      form.dataset.soldout = v.available ? 'false' : 'true';
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
      now.textContent = v.price;
      if (v.compare) { was.textContent = v.compare; was.hidden = false; now.classList.add('price__now--sale'); }
      else { was.hidden = true; now.classList.remove('price__now--sale'); }
      if (v.media) {
        var slide = $('[data-media-id="' + v.media + '"]', root);
        if (slide) showSlide($('[data-gallery]', root), Number(slide.getAttribute('data-slide')));
      }
      if (window.history && history.replaceState) {
        history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      }
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var chosen = $$('[data-option]:checked', root).map(function (el) { return el.value; });
      var match = variants.filter(function (v) { return v.options.join('\u0001') === chosen.join('\u0001'); })[0];
      update(match);
    });

    form.addEventListener('submit', function (e) {
      if (e.submitter && !e.submitter.matches('[data-add]')) return; /* let dynamic checkout button work */
      e.preventDefault();
      if (form.dataset.soldout === 'true') return;
      var qtyEl = $('[name=quantity]', form);
      var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
      btn.disabled = true;
      addToCart([{ id: Number(idInput.value), quantity: qty }])
        .then(function () { toast(cfg.added); })
        .catch(function (err) { toast(err.message || cfg.error, true); })
        .then(function () { btn.disabled = form.dataset.soldout === 'true'; });
    });
  });

  /* Hero slider */
  $$('[data-hero]').forEach(function (hero) {
    var track = $('[data-hero-track]', hero);
    var dots = $$('[data-dot]', hero);
    var slides = track.children.length;
    var idx = 0, paused = false, timer;
    function go(i) {
      idx = (i + slides) % slides;
      track.children[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
    track.addEventListener('scroll', function () {
      var w = track.clientWidth || 1;
      var i = Math.round(Math.abs(track.scrollLeft) / w);
      dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      idx = i;
    }, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-dot'))); }); });
    hero.addEventListener('mouseenter', function () { paused = true; });
    hero.addEventListener('mouseleave', function () { paused = false; });
    hero.addEventListener('focusin', function () { paused = true; });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slides > 1 && hero.getAttribute('data-autoplay') === 'true' && !reduce) {
      timer = setInterval(function () { if (!paused && !document.hidden) go(idx + 1); }, 6000);
    }
  });

  /* Countdown (real end date set by the merchant) */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date((el.getAttribute('data-end') || '').replace(' ', 'T'));
    if (isNaN(end.getTime())) { el.hidden = true; return; }
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var left = Math.floor((end.getTime() - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; clearInterval(iv); return; }
      var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      $('[data-cd="h"]', el).textContent = pad(h);
      $('[data-cd="m"]', el).textContent = pad(m);
      $('[data-cd="s"]', el).textContent = pad(s);
    }
    var iv = setInterval(tick, 1000);
    tick();
  });
})();
